var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "sr-user" },
        [
          _c(
            "el-button",
            {
              staticClass: "back-icon",
              attrs: { type: "text" },
              on: { click: _vm.goBack },
            },
            [_c("i", { staticClass: "el-icon-arrow-left" })]
          ),
          _vm._v(" "),
          _vm.visitDetails.accountInfo
            ? _c(
                "div",
                { staticClass: "avater-box" },
                [
                  _c("el-avatar", {
                    staticClass: "avater",
                    attrs: {
                      size: "small",
                      src:
                        _vm.visitDetails.accountInfo.avatar ||
                        require("@/assets/common/sr_avatar.jpg"),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "usrname" }, [
                      _vm._v(_vm._s(_vm.visitDetails.accountInfo.username)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "desc" }, [
                      _vm._v(
                        "ID:" + _vm._s(_vm.visitDetails.accountInfo.empNo)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "action-group" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "t-square-btn",
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-chat-dot-square",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.comment(
                                _vm.visitDetails.accountInfo,
                                "srEmpNo",
                                "empNo"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("storeComponents.common.comment"))
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-notebook-2",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.assignTasks(
                                _vm.visitDetails.accountInfo
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("storeComponents.common.task")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        { staticClass: "mt_20", attrs: { "no-title": "" } },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeType,
                callback: function ($$v) {
                  _vm.activeType = $$v
                },
                expression: "activeType",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("storeVisitReport.step.visitorRecord"),
                    name: "1",
                    lazy: "",
                  },
                },
                [
                  _c(
                    "el-form",
                    { attrs: { size: "small", "label-position": "top" } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "storeComponents.select.month"
                                    ),
                                  },
                                },
                                [
                                  _c("FormDatePicker", {
                                    attrs: {
                                      val: _vm.month,
                                      valueformat: "yyyyMM",
                                      type: "month",
                                      clearable: false,
                                      editable: false,
                                      placeholder: _vm.$t(
                                        "storeComponents.common.pleaseSelectMonth"
                                      ),
                                    },
                                    on: {
                                      "update:val": function ($event) {
                                        _vm.month = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sr-detail-data" },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("sfe.srDetail.visitStoreNum"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 10, push: 2 } }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("sfe.srDetail.storePlan")) +
                                  " / " +
                                  _vm._s(_vm.$t("sfe.srDetail.allPlan"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 3, push: 1 } }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(_vm._s(_vm.$t("sfe.srDetail.radio"))),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "mt_20", attrs: { align: "middle" } },
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c("div", { staticClass: "visit-number" }, [
                              _vm._v(_vm._s(_vm.visitDetails.visitQty)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 2 } }, [
                            _c("div", { staticClass: "store-visit" }, [
                              _vm._v(_vm._s(_vm.$t("sfe.srDetail.number"))),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt_10 store-visit" }, [
                              _vm._v(_vm._s(_vm.$t("sfe.srDetail.time"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c("div", { staticClass: "store-visit" }, [
                              _c("span", { staticClass: "visit-qty" }, [
                                _vm._v(_vm._s(_vm.visitDetails.visitQty)),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "/ " + _vm._s(_vm.visitDetails.planTaskQty)
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "visit-process" },
                                [
                                  _c("el-progress", {
                                    attrs: {
                                      percentage: _vm.visitDetails.qtyPercent,
                                      "show-text": false,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt_10 store-visit" }, [
                              _c("span", { staticClass: "visit-qty" }, [
                                _vm._v(_vm._s(_vm.visitDetails.visitDuration)),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "/ " +
                                    _vm._s(_vm.visitDetails.planTaskDuration)
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "visit-process" },
                                [
                                  _c("el-progress", {
                                    attrs: {
                                      percentage:
                                        _vm.visitDetails.durationPercent,
                                      "show-text": false,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 3, push: 1 } }, [
                            _c("div", { staticClass: "store-visit" }, [
                              _c("span", { staticClass: "visit-qty" }, [
                                _vm._v(_vm._s(_vm.visitDetails.qtyPercent)),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("%")]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt_10 store-visit" }, [
                              _c("span", { staticClass: "visit-qty" }, [
                                _vm._v(
                                  _vm._s(_vm.visitDetails.durationPercent)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("%")]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "list-title" }, [
                    _vm._v(_vm._s(_vm.$t("sfe.srDetail.visitStoreList"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "table-tab" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: {
                            round: "",
                            type: _vm.visitFlag === null ? "primary" : "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.typeChange(null)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("sfe.srDetail.all")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: {
                            round: "",
                            type: _vm.visitFlag === true ? "primary" : "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.typeChange(true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("sfe.srDetail.storeVisit")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: {
                            round: "",
                            type: _vm.visitFlag === false ? "primary" : "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.typeChange(false)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("sfe.srDetail.other")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "main-table-container" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.listLoading,
                              expression: "listLoading",
                            },
                          ],
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.currentVisitList,
                            stripe: "",
                            border: "",
                            "highlight-current-row": "",
                            "tooltip-effect": "dark",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "planTaskDateTime",
                              label: _vm.$t("sfe.srDetail.table.date"),
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("sfe.srDetail.table.thing"),
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.findTextByCode(
                                            scope.row.planTaskType
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "checkInDatetime",
                              label: _vm.$t("sfe.srDetail.table.time"),
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "planTaskTitle",
                              label: _vm.$t("sfe.srDetail.table.store"),
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "remark",
                              label: _vm.$t("sfe.srDetail.table.monthTimes"),
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("common.comment"),
                              width: "80",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.planTaskType === "A01"
                                      ? _c("el-button", {
                                          attrs: { icon: "el-icon-tickets" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toVisitDetail(
                                                scope.row
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("pagination", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.totalCount > 0,
                            expression: "totalCount>0",
                          },
                        ],
                        attrs: {
                          total: _vm.totalCount,
                          page: _vm.currPage,
                          limit: _vm.limit,
                        },
                        on: {
                          "update:page": function ($event) {
                            _vm.currPage = $event
                          },
                          "update:limit": function ($event) {
                            _vm.limit = $event
                          },
                          pagination: _vm.fetchVisitList,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("dashboard.saleDisplayForTab"),
                    name: "2",
                    lazy: "",
                  },
                },
                [_c("Home", { attrs: { "sr-emp-no": _vm.srEmpNo } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showCommentDialog
        ? _c("Commment", {
            attrs: {
              visible: _vm.showCommentDialog,
              "current-row": _vm.currentRow,
            },
            on: {
              submit: _vm.submitCommentDialog,
              close: _vm.closeCommentDialog,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AssignTasks", { ref: "AssignTasks" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }